		//引入
import server from "./request.js"; //路劲自己修改
const baseUrl = 'https://rdpjk.wkyyds.xyz/DataScreen1/GetData'
export const getport = (params, path) => {
    return server({
        url: path,
        method: "get" ,   //后端给什么写什么
        data: params
    })
}